import { Button, Card, Table } from 'antd';
import { ColumnsType } from 'antd/es/table';
import { QuestionGroup, QuestionGroupsMap } from '../../types/QuestionGroup';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

type PaginationState = {
  cursor: string | null;
  hasMore: boolean;
};

type PaginationMap = {
  beginner: PaginationState;
  easy: PaginationState;
  normal: PaginationState;
  hard: PaginationState;
};

type Props = {
  activeTabKey: string;
  onTabChange: (key: string) => void;
  questionGroupsMap?: QuestionGroupsMap;
  loading: boolean;
  loadingMore: boolean;
  paginationMap: PaginationMap;
  loadMore: (difficulty: 'beginner' | 'easy' | 'normal' | 'hard') => void;
  setQuestionGroup: (state: QuestionGroup) => void;
};

const QuestionGroupsTable: React.FC<Props> = ({
  activeTabKey,
  onTabChange,
  questionGroupsMap,
  loading,
  loadingMore,
  paginationMap,
  loadMore,
  setQuestionGroup,
}) => {
  const columns: ColumnsType<QuestionGroup> = [
    {
      title: '',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: '時間成績',
      dataIndex: ['bestScoreLabel', 'time'],
      key: 'timeScoreLabel',
    },
    {
      title: '正解率',
      dataIndex: ['bestScoreLabel', 'accuracy'],
      key: 'accuracyScoreLabel',
    },
    {
      title: '総合成績',
      dataIndex: ['bestScoreLabel', 'total'],
      key: 'totalScoreLabel',
    },
    {
      title: '各問題はこちら',
      dataIndex: 'key',
      key: 'key',
      render: (key, record) => (
        <Link
          onClick={() => {
            setQuestionGroup(record);
          }}
          to={`/time-attack`}
        >
          問題を解く
        </Link>
      ),
    },
  ];

  const renderTable = (difficulty: 'beginner' | 'easy' | 'normal' | 'hard') => {
    const dataSource = questionGroupsMap?.[difficulty];

    return (
      <>
        <Table
          columns={columns}
          dataSource={dataSource}
          loading={loading}
          pagination={false}
        />
        {paginationMap[difficulty].hasMore && (
          <LoadMoreContainer>
            <Button onClick={() => loadMore(difficulty)} loading={loadingMore}>
              もっと見る
            </Button>
          </LoadMoreContainer>
        )}
      </>
    );
  };

  const exerciseCorses: Record<string, React.ReactNode> = {
    beginner: renderTable('beginner'),
    easy: renderTable('easy'),
    normal: renderTable('normal'),
    hard: renderTable('hard'),
  };

  interface Level {
    key: string;
    tab: string;
  }

  const level: Level[] = [
    {
      key: 'beginner',
      tab: '入門',
    },
    {
      key: 'easy',
      tab: '初級',
    },
    {
      key: 'normal',
      tab: '中級',
    },
    {
      key: 'hard',
      tab: '上級',
    },
  ];

  return (
    <StyledCard
      tabList={level}
      activeTabKey={activeTabKey}
      onTabChange={(key) => onTabChange(key)}
    >
      {exerciseCorses[activeTabKey]}
    </StyledCard>
  );
};

const StyledCard = styled(Card)`
  width: 70%;
  min-width: 550px;
`;

const LoadMoreContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 16px 0;
`;

export default QuestionGroupsTable;
